import React from "react";
import { ShiftPageHead } from "./lib/shiftList";
import MyShiftExchangesComponent from "./MyShiftExchangesComponent";
import MyShiftOffersComponent from "./MyShiftOffersComponent";
/**
 * The Mine byttevagter side of the Byttevagter page (the board *Mine byttevagter*): the same head as
 * the list of everybody's byttevagter, with the switch on its other half, and under it the two ends
 * of the loop - what the volunteer has put on the exchange with the offers that came, and the offers
 * they have sent to others. The page at `/min-side/mine-byttevagter` hosts it through the list block,
 * which is what the offer SMS and the menu link to.
 */
export default class MyByttevagterPage extends React.Component {
    render() {
        return (React.createElement("div", { className: "bi-sl-page bi-mb-page" },
            React.createElement(ShiftPageHead, { title: "Byttevagter" },
                React.createElement("div", { className: "bi-seg", role: "group", "aria-label": "Vis byttevagter" },
                    React.createElement("a", { href: "/byttevagter/" }, "Alle"),
                    React.createElement("button", { type: "button", "aria-pressed": "true" }, "Mine byttevagter"))),
            React.createElement("div", { className: "bi-mb" },
                React.createElement(MyShiftExchangesComponent, Object.assign({}, this.props)),
                React.createElement(MyShiftOffersComponent, Object.assign({}, this.props)))));
    }
}
